import 'modern-normalize'
import './src/global.css'

export const wrapRootElement = ({ element }) => element
